import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { HeatmapCell } from "../models/experience.model";

@Component({
  selector: "app-exp-heatmap",
  standalone: true,
  imports: [],
  template: `
    @if (labels.length) {
      <div class="heatmap">
        <div class="hm-grid" [style.gridTemplateColumns]="gridCols">
          <div></div>
          @for (l of labels; track l) {
            <div class="hm-label col">{{ l }}</div>
          }
          @for (row of labels; track row; let i = $index) {
            <div class="hm-label row">{{ row }}</div>
            @for (col of labels; track col; let j = $index) {
              <div
                class="hm-cell"
                [class.diag]="i === j"
                [style.background]="cellColor(matrix[i][j])"
                (click)="onCellClick(i, j)"
                [title]="formatValue(matrix[i][j])"
              >
                {{ formatValue(matrix[i][j]) }}
              </div>
            }
          }
        </div>
      </div>
    }
  `,
})
export class HeatmapComponent implements OnChanges {
  @Input() labels: string[] = [];
  @Input() matrix: number[][] = [];
  @Input() mode: "divergent" | "sequential" = "divergent";
  @Input() decimals = 2;
  @Input() absolute = false;

  @Output() cellClick = new EventEmitter<HeatmapCell>();

  gridCols = "";
  private max = 1;
  private min = -1;

  ngOnChanges(): void {
    const n = this.labels.length;
    this.gridCols = `120px repeat(${n}, minmax(0, 1fr))`;
    const flat: number[] = [];
    for (const row of this.matrix) {
      for (const v of row) {
        if (typeof v === "number" && isFinite(v)) flat.push(v);
      }
    }
    this.max = flat.length ? Math.max(...flat) : 1;
    this.min = flat.length ? Math.min(...flat) : -1;
  }

  cellColor(v: number): string {
    if (v === null || v === undefined || !isFinite(v)) return "transparent";
    if (this.mode === "divergent") {
      const ref = Math.max(Math.abs(this.max), Math.abs(this.min)) || 1;
      const t = Math.max(-1, Math.min(1, v / ref));
      if (t >= 0) return `rgba(0, 229, 160, ${0.08 + t * 0.55})`;
      return `rgba(255, 92, 122, ${0.08 + Math.abs(t) * 0.55})`;
    }
    const ref = Math.max(Math.abs(this.max), Math.abs(this.min)) || 1;
    const t = Math.min(1, Math.abs(v) / ref);
    return `rgba(124, 92, 255, ${0.08 + t * 0.7})`;
  }

  formatValue(v: number): string {
    if (v === null || v === undefined || !isFinite(v)) return "—";
    return v.toFixed(this.decimals);
  }

  onCellClick(i: number, j: number): void {
    this.cellClick.emit({
      row: i,
      col: j,
      rowLabel: this.labels[i],
      colLabel: this.labels[j],
      value: this.matrix[i][j],
    });
  }
}
